import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './HeaderDashboard';
import { useUIStore } from '@/store/uiStore';
import { cn } from '@/utils/cn';

export const Layout = () => {
  const { sidebarOpen } = useUIStore();

  return (
    <div className="min-h-screen bg-competition-bg">
      <Sidebar />
      <div className={cn('flex flex-col transition-all duration-300', sidebarOpen ? 'pl-64' : 'pl-16')}>
        <Header />
        <main className="flex-1 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
